import { toNumberOrUndefined } from 'commerce-products-lib/utils/toNumber';
import { getProperty } from 'customer-data-objects/objects/ObjectAccessors';
const BUNDLE_ITEM_PROPERTY_BLOCK_LIST = new Set(['hs_product_id', 'hs_updated_by_user_id', 'hs_object_source_label', 'hs_created_by_user_id', 'hs_object_id', 'hs_lastmodifieddate']);
const SYNC_BUNDLE_ITEM_PROPERTY_ALLOW_LIST = new Set(['hs_sync_with_product', 'quantity', 'hs_discount_percentage', 'hs_cost_of_goods_sold', 'hs_position']);
const mapPropertiesToArray = (subject, propertyBlocklist, propertyAllowlist) => Object.entries(subject.properties).reduce((acc, [name, {
  value
}]) => {
  if (!(propertyBlocklist !== null && propertyBlocklist !== void 0 && propertyBlocklist.has(name)) && (!propertyAllowlist || propertyAllowlist.has(name))) {
    acc.push({
      name,
      value
    });
  }
  return acc;
}, []);
export const getBundlePropertiesFromBundleForSave = bundle => mapPropertiesToArray(bundle);
const getBundleItemPropertiesFromBundleItemForSave = bundleItem => mapPropertiesToArray(bundleItem, BUNDLE_ITEM_PROPERTY_BLOCK_LIST, getProperty(bundleItem, 'hs_sync_with_product') === 'true' ? SYNC_BUNDLE_ITEM_PROPERTY_ALLOW_LIST : undefined);
export const getBundleItemsFromBundleItemMapForSave = bundleItems => [...bundleItems.values()].reduce((acc, bundleItem) => {
  const productId = toNumberOrUndefined(getProperty(bundleItem, 'hs_product_id'));
  if (productId != null) {
    acc.push({
      bundleItemProperties: getBundleItemPropertiesFromBundleItemForSave(bundleItem),
      productId
    });
  }
  return acc;
}, []);
export const parseBundle = bundle => {
  const {
    bundleProperties
  } = bundle;
  return {
    objectId: bundle.id,
    properties: bundleProperties.reduce((properties, property) => {
      if (property.name) {
        properties[property.name] = {
          value: property.value,
          name: property.name
        };
      }
      return properties;
    }, {})
  };
};
export const parseBundleItems = bundleItems => bundleItems.reduce((acc, bundleItem) => {
  const productBundleItem = {
    objectId: bundleItem.id,
    properties: bundleItem.bundleItemProperties.reduce((properties, property) => {
      if (property.name) {
        properties[property.name] = {
          value: property.value,
          name: property.name
        };
      }
      return properties;
    }, {})
  };
  acc.set(bundleItem.id, productBundleItem);
  return acc;
}, new Map());
export const getPropertyDifferences = (subject, savedSubject) => {
  if (!(subject !== null && subject !== void 0 && subject.properties)) {
    return [];
  }
  return [...Object.entries(subject.properties)].reduce((acc, [name, {
    value
  }]) => {
    const savedValue = getProperty(savedSubject, name);
    if (value !== savedValue) {
      acc.push({
        name,
        value,
        sourceVid: []
      });
    }
    return acc;
  }, []);
};
export const getBundleChangesForSave = (bundle, savedBundle) => getPropertyDifferences(bundle, savedBundle);
const getUpdatedBundleItemProperties = (bundleItem, savedBundleItem) => ({
  bundleItemId: bundleItem.objectId,
  bundleItemProperties: getPropertyDifferences(bundleItem, savedBundleItem)
});
export const getBundleItemChangesForSave = (bundleItems, savedBundleItems) => {
  const createdBundleItems = [];
  const updatedBundleItems = [];
  const deletedBundleItems = [];
  bundleItems.forEach((bundleItem, id) => {
    const savedBundleItem = savedBundleItems.get(id);
    if (!savedBundleItem) {
      const productId = toNumberOrUndefined(getProperty(bundleItem, 'hs_product_id'));
      if (productId != null) {
        createdBundleItems.push({
          productId,
          bundleItemProperties: getBundleItemPropertiesFromBundleItemForSave(bundleItem).map(({
            name,
            value
          }) => ({
            name,
            value,
            sourceVid: []
          }))
        });
      }
    } else {
      const updatedBundleItem = getUpdatedBundleItemProperties(bundleItem, savedBundleItem);
      if (updatedBundleItem.bundleItemProperties.length > 0) {
        updatedBundleItems.push(updatedBundleItem);
      }
    }
  });
  savedBundleItems.forEach((_savedBundleItem, id) => {
    if (!bundleItems.has(id)) {
      deletedBundleItems.push(id);
    }
  });
  return {
    createdBundleItems,
    updatedBundleItems,
    deletedBundleItems
  };
};